import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronLeft, ChevronRight, MinusIcon, PlusIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Image from "../../components/Image";
import "../shop_cart/cart.css";
import { api } from "../../api/api";
import {
  b2bcredit,
  Coupan,
  getPromoCodeUrl,
  point_url,
  // Produts_Add,
  Wallet_url,
} from "../../api/urls";
import { Box } from "@mui/material";

import {
  setBuyNowData,
  setCredit,
  setPoints,
  setWallet,
} from "../../Redux/CartSlice";
import OrderSummarySection from "../../components/OrderSummary";
import useFetch from "../../hooks/useFetch";
import { setCreditData } from "../../Redux/B2b";
import { setWalletBalance } from "../../Redux/Wallet";
import { setMinCapPoints, setPointBalance } from "../../Redux/Point";
import { toast } from "react-toastify";
import { useIsMobile } from "../../hooks/useIsMobile";
// import { useParams } from "react-router-dom";
const BuyNow = () => {
  const dispatch = useDispatch();
  const { data: walletData } = useFetch(Wallet_url);
  const { data: pointsData } = useFetch(point_url);
  const { data: creditsData } = useFetch(b2bcredit);
  // const params = useParams();
  // const { data: products, loading } = useFetch(Produts_Add + params.id + "/");
  useEffect(() => {
    if (walletData && pointsData && creditsData) {
      dispatch(setPointBalance(pointsData?.wallet_coin));
      dispatch(setMinCapPoints(Number(pointsData?.min_pts_cap_pts)));
      dispatch(setWalletBalance(walletData?.wallet_money));
      dispatch(setCreditData(creditsData));
    }
  }, [dispatch, walletData, pointsData, creditsData]);
  const [couponIndex, setCouponIndex] = useState(0);
  const [isapplied, setisApplied] = useState(false);
  const isMobile = useIsMobile();
  const couponsPerPage = isMobile ? 1 : 3;

  const handleNext = () => {
    if (couponIndex + couponsPerPage < appliedCoupons.length) {
      setCouponIndex(couponIndex + 1);
    }
  };

  const handlePrev = () => {
    if (couponIndex > 0) {
      setCouponIndex(couponIndex - 1);
    }
  };

  // useEffect(() => {
  //   if (walletData) {
  //     dispatch(setWalletBalance(walletData?.wallet_money));
  //   }
  //   if (pointsData) {
  //     dispatch(setPointBalance(pointsData?.wallet_coin));
  //     dispatch(setMinCapPoints(Number(pointsData?.min_pts_cap_pts)));
  //   }
  //   if (creditsData) {
  //     dispatch(setCreditData(creditsData));
  //   }
  // }, [dispatch, walletData, pointsData, creditsData]);

  const { points: Point, minCapPoints: minCap } = useSelector(
    (state) => state.point,
  );
  const credit = useSelector((state) => state.credit);

  const productcart = useSelector((state) => state.cart.items || []);
  const buyNowData = useSelector((state) => state.cart.buyNowData);

  const [quantity, setQuantity] = useState(buyNowData?.selected_quantity || 1);

  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [promoCodeInput, setPromoCodeInput] = useState("");
  const [appliedCoupons, setAppliedCoupons] = useState([]);
  // const [lastToggledOption, setLastToggledOption] = useState(null);
  // const [consumedBy, setConsumedBy] = useState("");
  const [totals, setTotals] = useState({
    total: 0,
    discount: 0,
    sellingPrice: 0,
    finalTotal: 0,
    couponDiscount: 0,
    deliveryCharges: 0,
    packingCharges: 0,
    discountPercent: 0,
    pointsUsed: 0,
    pointsUsedInRupees: 0,
  });
  const [walletUsed, setWalletUsed] = useState(0);
  // const [selectedSize, setSelectedSize] = useState(null);
  const [amountToPay, setAmountToPay] = useState(totals.finalTotal);
  // const [minCap, Setmincap] = useState(0);
  const [creditUsedAmount, setCreditUsedAmount] = useState(0);
  const [paymentOptions, setPaymentOptions] = useState({
    wallet: false,
    points: false,
    credit: false,
  });
  const selectedSizeData = buyNowData?.inventory[0].size_and_price?.find(
    (item) => item.size === buyNowData.selected_size,
  );
  const navigate = useNavigate();
  const disableCheckbox = amountToPay === 0;
  const { data: minCapData, loading: minCapLoading } = useFetch(point_url);

  const calculateTotal = () => {
    let totalMRP = 0;
    let totalDiscount = 0;
    let totalSellingPrice = 0;
    let deliveryCharges = 0;
    let packingCharges = 0;

    const qty = quantity || 1;
    // const country = buyNowData.country_details || {};
    const mrp = parseFloat(buyNowData.product_price) || 0;
    const discount = parseFloat(buyNowData.you_save) || 0;
    // const selling = parseFloat(buyNowData.sell_price) || 0;
    const discount_price = parseFloat(buyNowData.discount_price) || 0;

    totalMRP += mrp * qty;
    totalDiscount += discount * qty;
    totalSellingPrice += discount_price * qty;

    deliveryCharges += parseFloat(buyNowData.shipping_charges || 0) * qty;
    packingCharges +=
      parseFloat(buyNowData.packing_and_forwarding_charges || 0) * qty;
    const couponDiscount = appliedCoupons.reduce(
      (sum, coupon) => sum + (coupon?.value || 0),
      0,
    );
    // console.log(selectedSize, " i am the buyNowData")
    const discountedTotal =
      appliedCoupons.length > 0 &&
      appliedCoupons[0]?.discountedPrice !== undefined
        ? appliedCoupons[0].discountedPrice
        : totalSellingPrice;
    const finalTotal =
      parseFloat(discountedTotal) + deliveryCharges + packingCharges;

    const discountPercent =
      productcart && productcart?.length > 0
        ? productcart[0]?.country_details?.discout_percent
        : 0;

    const pointConversionRate = 100;
    const maxPointsPercent = 2;
    const availablePoints = Point;

    const maxPointsInRupees = parseFloat(
      (totalSellingPrice * maxPointsPercent) / 100,
    );
    const maxPointsAllowed = Math.floor(
      maxPointsInRupees * pointConversionRate,
    ); // e.g., ₹5.14 * 100 = 514 points

    const pointsUsed =
      paymentOptions.points && availablePoints >= minCap
        ? Math.min(availablePoints, maxPointsAllowed)
        : 0;

    const pointsUsedInRupees = pointsUsed / pointConversionRate;

    return {
      total: parseFloat(totalMRP.toFixed(2)),
      discount: parseFloat(totalDiscount.toFixed(2)),
      sellingPrice: parseFloat(totalSellingPrice.toFixed(2)),
      finalTotal: isNaN(finalTotal) ? 0 : parseFloat(finalTotal.toFixed(2)),
      couponDiscount: parseFloat(couponDiscount.toFixed(2)),
      deliveryCharges: parseFloat(deliveryCharges.toFixed(2)),
      packingCharges: parseFloat(packingCharges.toFixed(2)),
      discountPercent,
      pointsUsed,
      pointsUsedInRupees: parseFloat(pointsUsedInRupees.toFixed(2)),
    };
  };
  // console.log(buyNowData, "i am buy now data")
  useEffect(() => {
    const totals = calculateTotal();
    setTotals(totals);
  }, [quantity, appliedCoupons, Point, paymentOptions]);
  const balance = useSelector((state) => state.wallet.balance);

  useEffect(() => {
    let payable = totals.finalTotal;

    // 1️⃣ Coupon
    if (selectedCoupon && isapplied) {
      payable -= selectedCoupon.value;
    }
    payable = Math.max(0, payable);

    // 2️⃣ Points
    let pointsUsedRupees = 0;
    if (paymentOptions.points && Point >= minCapData?.min_pts_cap_pts) {
      pointsUsedRupees = Math.min(totals.pointsUsedInRupees, payable);
      payable -= pointsUsedRupees;
    }

    // 3️⃣ Wallet
    let walletUsedNow = 0;
    if (paymentOptions.wallet) {
      walletUsedNow = Math.min(balance, payable);
      payable -= walletUsedNow;
    }
    setWalletUsed(walletUsedNow);

    // 4️⃣ Credit
    let creditUsedNow = 0;
    if (paymentOptions.credit) {
      creditUsedNow = Math.min(credit.data || 0, payable);
      payable -= creditUsedNow;
    }
    setCreditUsedAmount(creditUsedNow);

    setAmountToPay(Number(payable.toFixed(2)));
  }, [
    totals.finalTotal,
    totals.pointsUsedInRupees,
    selectedCoupon,
    isapplied,
    paymentOptions,
    Point,
    balance,
    credit.data,
    minCapData,
  ]);

  useEffect(() => {
    api
      .get(Coupan)
      .then((response) => {
        setAppliedCoupons(response.data);
      })

      .catch((error) => {
        console.error("GET Error:", error?.response?.data || error.message);
      });
  }, []);

  const handleCouponClick = (coupon) => {
    // console.log(coupon, "coupon")
    setSelectedCoupon(coupon);
  };

  const handleIncrement = () => {
    const selectedStock = selectedSizeData?.stock ?? "";
    // console.log(selectedSizeData)
    if (quantity < selectedStock) {
      setQuantity((prev) => prev + 1);
    } else {
      toast.error(`Only ${selectedStock} items available for this size!`);
    }
  };
  const handleDecrement = () => {
    if (quantity !== 1) {
      setQuantity((prev) => prev - 1);
    }

    // });
  };

  return (
    <div className="shopcart-wrapper">
      <div className="shopcart-container">
        <div className="items-section">
          <div className="cart-header">
            <div
              className="back-button"
              onClick={() => navigate(`/products/${buyNowData.id}`)}
            >
              <ChevronLeft size={20} />
              <span>Back to Store</span>
            </div>
            <h2 className="cart-title">Buy Now</h2>
          </div>
          <div className="cart-item-main">
            <div className="cart-item">
              <div
                className="item-image-container cursor-pointer"
                onClick={() => {
                  navigate(`/products/${buyNowData.id}`);
                }}
              >
                <Image
                  src={buyNowData.inventory?.[0]?.images?.[0]?.img}
                  alt={buyNowData.product_title}
                  className="item-image"
                />
              </div>

              <div className="item-content">
                <div className="item-header">
                  <h3 className="item-title">{buyNowData.title}</h3>
                </div>

                <div className="item-details-grid">
                  <div className="detail-row">
                    <span className="detail-label">Order ID:</span>
                    <span className="detail-value">{buyNowData.id}</span>
                  </div>

                  {buyNowData.selected_size_name && (
                    <div className="detail-row">
                      <span className="detail-label">Size:</span>
                      <span className="detail-value">
                        {buyNowData.selected_size_name}
                      </span>
                    </div>
                  )}

                  {buyNowData.selected_color && (
                    <div className="detail-row">
                      <span className="detail-label">Colour:</span>
                      <span className="detail-value">
                        {buyNowData.selected_color}
                      </span>
                    </div>
                  )}

                  <div className="detail-row">
                    <span className="detail-label">Price:</span>

                    <span className="detail-value">
                      ₹{buyNowData.discount_price}
                    </span>
                  </div>
                </div>

                {/* Quantity */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <button
                    className="border p-2 rounded-md h-10 w-10 flex items-center justify-center disabled:bg-gray-200 disabled:text-black bg-black text-white"
                    onClick={() => handleDecrement(buyNowData.id)}
                    disabled={quantity === 1}
                  >
                    <MinusIcon size={18} />
                  </button>
                  <div className="border p-2 rounded-md h-10 w-10 flex items-center justify-center">
                    {quantity}
                  </div>
                  <button
                    className={`border p-2 rounded-md h-10 w-10 flex items-center justify-center disabled:bg-gray-200 disabled:text-black bg-black text-white`}
                    onClick={() => handleIncrement(buyNowData.id)}
                    disabled={quantity >= (selectedSizeData?.stock ?? 0)}
                  >
                    <PlusIcon size={18} />
                  </button>
                </Box>
              </div>
            </div>

            {appliedCoupons?.length > 0 && (
              <div className="applied-coupons items-center mt-5">
                {appliedCoupons?.length > couponsPerPage && (
                  <ChevronLeft onClick={handlePrev} />
                )}

                <div className="flex md:flex-row flex-col gap-2 flex-1">
                  {appliedCoupons
                    .slice(couponIndex, couponIndex + couponsPerPage)
                    .map((coupon) => (
                      <div
                        key={coupon.code}
                        style={{
                          cursor: "pointer",
                          flex: 1,
                          gap: 5,
                        }}
                        className="flex-1 flex border p-2 w-full rounded-lg gap-2 cursor-pointer hover:bg-gray-100"
                        onClick={() => handleCouponClick(coupon)}
                      >
                        {" "}
                        <Image
                          src={coupon?.coupon_image}
                          alt="cpn"
                          fill
                          style={{
                            height: "40px",
                            width: "40px",
                            borderRadius: "50%",
                            border: "1px solid #ACACAC",
                          }}
                        />
                        <div className="coupon-info">
                          <div style={{ textAlign: "start" }}>
                            <div className="coupon-code">
                              {coupon.promocode}
                            </div>
                            <div className="coupon-desc">
                              Get {coupon.discount_upto}% off on minimum
                              purchase of {coupon.currency_symbol}
                              {coupon.min_txn}/-
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                {appliedCoupons?.length > couponsPerPage && (
                  <ChevronRight onClick={handleNext} />
                )}
              </div>
            )}
          </div>
        </div>

        <div style={{ marginTop: "38px" }}>
          <OrderSummarySection
            paymentOptions={paymentOptions}
            // setLastToggledOption={setLastToggledOption}
            setWalletUsed={setWalletUsed}
            selectedCoupon={selectedCoupon}
            setSelectedCoupon={setSelectedCoupon}
            setPaymentOptions={setPaymentOptions}
            totals={calculateTotal()}
            setAmountToPay={setAmountToPay}
            amountToPay={amountToPay}
            // setConsumedBy={setConsumedBy}
            promoCodeInput={promoCodeInput}
            setPromoCodeInput={setPromoCodeInput}
            disableCheckbox={disableCheckbox}
            // consumedBy={consumedBy}
            walletUsed={walletUsed}
            minCap={minCap}
            minCapLoading={minCapLoading}
            creditUsedAmount={creditUsedAmount}
            setCartItems={setBuyNowData}
            setCredit={setCredit}
            productcart={productcart}
            setWallet={setWallet}
            setPoints={setPoints}
            setAppliedCoupons={setAppliedCoupons}
            appliedCoupons={appliedCoupons}
            calculateTotal={calculateTotal}
            getPromoCodeUrl={getPromoCodeUrl}
            // buynow
            isBuyNow={true}
            quantity={quantity}
            buyNowData={buyNowData}
            setisApplied={setisApplied}
            isapplied={isapplied}
          />
        </div>
      </div>
    </div>
  );
};

export default BuyNow;
